import { timeline } from "@/mocks/home";
import SectionHeading from "./SectionHeading";

export default function Timeline() {
  return (
    <section id="timeline" className="w-full bg-background-50 px-4 py-16 md:px-8 md:py-24">
      <div className="mx-auto w-full max-w-6xl">
        <SectionHeading
          eyebrow="剧情看点"
          title="六个阶段，顺着脉络看下去"
          desc="从入宅到收尾，各阶段看点与常见删减位置都标了出来，方便你判断该重点补哪一段。"
        />

        <ol className="mt-10 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3">
          {timeline.map((item, idx) => (
            <li
              key={item.phase}
              className="relative flex flex-col rounded-lg border border-background-200 bg-background-100/70 p-5"
            >
              <div className="flex items-center gap-3">
                <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-accent-500 font-heading text-sm font-bold text-background-50 dark:text-foreground-950">
                  {idx + 1}
                </span>
                <div>
                  <h3 className="font-heading text-base font-bold text-foreground-950">
                    {item.phase}
                  </h3>
                  <p className="font-label text-xs text-secondary-700">{item.point}</p>
                </div>
              </div>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}